export const getCurrentPosition = () => {
  if (typeof navigator !== 'undefined' && 'geolocation' in navigator) {
    return new Promise((resolve, reject) => navigator.geolocation.getCurrentPosition(resolve, reject, { timeout: 10000 }))
  }
}
